import { isValueEmpty } from '@awp/helpers/utilsReact';
import { parseISO } from 'date-fns';
import _find from 'lodash/find';
import { CrudService } from '@awp/shared/CrudService';
import React from 'react';

export class WeatherStationService extends CrudService {
  constructor(mode: string) {
    const entityName = 'Weather Station';
    const entityPluralName = 'Weather Stations';

    super({ entityName, entityPluralName, mode });
  }

  getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  getColumns(props: any): any {
    /* Do Nothing */
  }

  getFields(props: any): React.ReactElement {
    return <></>;
  }

  getValidations(props?: any): any {
    /* Do Nothing */
  }

  mapFormToDTO(props: any): any {
    /* Do Nothing */
  }

  mapInitialValues(props: any): any {
    const { entity, getDefaultStatusType, ...rest } = props;

    return {
      name: entity.Name ?? '',
      shortName: entity.ShortName ?? '',
      number: entity.Number ?? '',
      statustypeid: entity.StatusTypeId
        ? { value: entity.StatusTypeId, label: entity.StatusTypeName }
        : getDefaultStatusType(),
      typeid: entity.TypeId ? { value: entity.TypeId, label: entity.TypeName } : { value: 0, label: '		' }, // Note: This is to match 'fetchWeatherStationStatusTypes.fulfilled'
      longitude: entity.Longitude ?? '',
      latitude: entity.Latitude ?? '',
      elevation: entity.Elevation ?? '',
      description: entity.Description ?? '',
      operationstartdate: isValueEmpty(entity.OperationStartDate)
        ? null //@ts-expect-error - Add Type
        : new parseISO(entity.OperationStartDate),
      operationenddate: isValueEmpty(entity.OperationEndDate)
        ? null //@ts-expect-error - Add Type
        : new parseISO(entity.OperationEndDate),
      eet: _find(entity?.GeographicAreas, { GeographicAreaTypeName: 'EET SERVICE AREA' })?.DropdownText ?? '',
      maintenanceContractorArea:
        _find(entity?.GeographicAreas, { GeographicAreaTypeName: 'CONTRACT AREA' })?.DropdownText ?? '',
    };
  }

  cleanFormValues(props: any): any {
    const { entity, ...rest } = props;

    return {
      ...entity,
      longitude: entity.longitude ? parseFloat(entity.longitude) : null,
      latitude: entity.latitude ? parseFloat(entity.latitude) : null,
      elevation: entity.elevation ? parseFloat(entity.elevation) : null,
    };
  }
}
